import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../actions";
import { useLocation } from "react-router-dom";
import * as Template from "../../templates";
import { formatNumber } from "../../libraries/helper";
 
export default () => {

  const moduleName = "wholesale_shippings";
  const location = useLocation()
  const appReducer = useSelector((state) => state.appReducer);
  const dispatch = useDispatch();
  const [rows, setRows] = useState([])
  const [totalPages, setTotalPages] = useState(0)

  const handleDelete = id => dispatch(actions.destroy(id, moduleName))

  useEffect(() => {
    dispatch(actions.list(moduleName, location.search));
  }, [appReducer.wholesale_shippings_destroy, location.search]);

  useEffect(() => {
    if (appReducer.wholesale_shippings_list != undefined) {
      setRows(appReducer.wholesale_shippings_list.data)
      setTotalPages(appReducer.wholesale_shippings_list.count)
    }
  }, [appReducer])


  const columns = [
    {
      name: 'نام',
      selector: row => row.name,
    },
    {
      name: 'بازه وزنی',
      selector: row => `${row.min_weight} - ${row.max_weight}`,
    },
    {
      name: 'استان',
      selector: row => row.province.name,
    },
    {
      name: 'بازه قیمتی',
      selector: row => `${formatNumber(row.price)} تومان `,
    },
    {
      name: 'تاریخ ایجاد',
      selector: row => row.created_at,
    },
    {
      name: 'عملیات',
      selector: row => <Template.TableButton handleDelete={() => handleDelete(row.id)} row={row} location={location} />,
    },
  ];

  return <Template.Table  count={totalPages}  columns={columns} data={rows} />;

};
